import MediaMarketAnalyticsTheme from "css/themes/media-market/MediaMarketAnalyticsTheme.css";
import d3 from "d3";
import React from "react";
import { H4, Tiny } from "visual-components/util/texts";

const FlatRateStats = (props) => {
  const { isLive, expectedViews, status } = props;

  return (
    <React.Fragment>
      <div className={MediaMarketAnalyticsTheme.dealStatContainer} style={{ textAlign: "left" }}>
        <div className={MediaMarketAnalyticsTheme.dealStatValue}>
          <H4 white={isLive && status === "live"} style={{ fontSize: "24px" }}>
            <em>{d3.format(",")(expectedViews)}</em>
          </H4>
        </div>
        <Tiny white={isLive && status === "live"} style={{ textAlign: "none" }}>
          Expected Reach
        </Tiny>
      </div>
    </React.Fragment>
  );
};

export default FlatRateStats;
